// src/task/TaskBoardWrapper.js
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import TaskBoard from './TaskBoard';
import './bord.css';

const TaskBoardWrapper = () => {
  // إذا عاد null أو undefined نستخدم كائن فارغ
  const outlet = useOutletContext() || {};

  // نُفكّك الخصائص مع قيم افتراضية
  const {
    searchTerm = '',
    dateStart = null,
    dateEnd   = null,
  } = outlet;

  return (
    <TaskBoard
      searchTerm={searchTerm}
      dateStart={dateStart}
      dateEnd={dateEnd}
    />
  );
};

export default TaskBoardWrapper;
